export default __webpack_public_path__ + "static/media/Bilo3-13.cc8a0189.jpg";